import { render, staticRenderFns } from "./ErpEntitySettings.vue?vue&type=template&id=da44be08&scoped=true"
import script from "./ErpEntitySettings.vue?vue&type=script&lang=js"
export * from "./ErpEntitySettings.vue?vue&type=script&lang=js"
import style0 from "./ErpEntitySettings.vue?vue&type=style&index=0&id=da44be08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da44be08",
  null
  
)

export default component.exports